import React, {Suspense} from 'react';
import {ThemeProvider} from "@mui/material/styles";
import rtlPlugin from "stylis-plugin-rtl";
import {CacheProvider} from "@emotion/react"
import {Helmet, HelmetProvider} from "react-helmet-async";
import createCache from "@emotion/cache";
import {prefixer} from "stylis"
import './App.css';
import {theme} from "./shared/UIElement/theme/Theme";
import 'react-toastify/dist/ReactToastify.css';


//Note Create Custom Theme
import {QueryClient, QueryClientProvider} from 'react-query';
import {ToastContainer} from 'react-toastify';


//Note Create RTL Cache
const cacheRTL = createCache({
    key: "muirtl",
    stylesPlugins: [prefixer, rtlPlugin]
})
const queryClient = new QueryClient();
const LazyAppRouter = React.lazy(() => import('./AppRouter'))

function App() {
    return (
        <Suspense fallback={<div style={{
            display: "flex", justifyContent: "center",
            marginTop: "30px"
        }}>
            <span>سلام به پنل مدیریت  آنوی خوش اومدی</span>
        </div>}>

            <CacheProvider value={cacheRTL}>
                <ThemeProvider theme={theme}>
                    <HelmetProvider>
                        <Helmet>
                            <title>
                                پنل ادمین آنوی
                            </title>
                        </Helmet>
                        <div className="App rtl">
                            <QueryClientProvider client={queryClient}>
                                <LazyAppRouter/>
                                <ToastContainer/>
                                {/*<ReactQueryDevtools initialIsOpen={false}/>*/}
                            </QueryClientProvider>
                        </div>
                    </HelmetProvider>
                </ThemeProvider>
            </CacheProvider>
        </Suspense>

    );
}

export default App;
